export const SET_VIEW_ASSOCIATE = 'app/findAssociates/SET_VIEW_ASSOCIATE';
